import styled, { css, keyframes } from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

// Сцена 1280×720: розміри в px розраховані під демонстрацію екрана (великі шрифти)

const rise = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const stateColors = (state) =>
  state === "ok"
    ? css`border-color: ${colors.success}; background: ${colors.successSoft};`
    : state === "bad"
    ? css`border-color: ${colors.danger}; background: ${colors.dangerSoft};`
    : state === "late"
    ? css`border-color: ${colors.amberDeep}; background: ${colors.amberSoft};`
    : state === "tried"
    ? css`border-style: dashed; border-color: ${colors.danger}; color: ${colors.danger}; text-decoration: line-through;`
    : "";

export const Credit = styled.span`
  position: absolute;
  right: 10px;
  bottom: 8px;
  padding: 2px 8px;
  border-radius: ${radius.pill};
  font-size: 11px;
  color: #FFFFFF;
  background: rgba(0, 0, 0, 0.4);
`;

// ---------- cover ----------
export const Cover = styled.div`
  display: grid;
  grid-template-columns: 1fr 520px;
  height: 100%;
  background:
    radial-gradient(120% 120% at 0% 100%, rgba(244, 182, 63, 0.22) 0%, rgba(244, 182, 63, 0) 45%),
    linear-gradient(135deg, ${colors.brandDark} 0%, ${colors.brandDeep} 70%, ${colors.brand} 100%);
  color: #FFFFFF;
`;

export const CoverText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  padding: 56px;
  animation: ${rise} 0.5s ease-out;
`;

export const CoverBadge = styled.span`
  align-self: flex-start;
  padding: 8px 16px;
  border-radius: ${radius.pill};
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.16);
`;

export const CoverTitle = styled.h1`
  font-size: 68px;
  font-weight: 800;
  line-height: 1.05;
`;

export const CoverSubtitle = styled.p`
  font-size: 24px;
  font-weight: 600;
  opacity: 0.85;
`;

export const Goals = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
`;

export const GoalsTitle = styled.li`
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  opacity: 0.7;
`;

export const Goal = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  font-weight: 700;
`;

export const GoalIcon = styled.span`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  color: ${colors.brandDark};
  background: ${colors.amber};
`;

export const CoverImage = styled.div`
  position: relative;
  margin: 36px 36px 36px 0;
  border-radius: ${radius.xl};
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// ---------- layout helpers ----------
export const Split = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.$withImage ? "minmax(0, 1fr) minmax(0, 1fr)" : "1fr")};
  gap: 32px;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const SideImage = styled.div`
  position: relative;
  border-radius: ${radius.xl};
  overflow: hidden;
  box-shadow: ${(props) => (props.$contain ? "none" : shadow.card)};

  img {
    width: 100%;
    height: 100%;
    object-fit: ${(props) => (props.$contain ? "contain" : "cover")};
  }
`;

// ---------- talk ----------
export const Questions = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const PhraseBox = styled.li`
  padding: 18px 22px;
  border-radius: ${radius.lg};
  background: linear-gradient(135deg, ${colors.brandSoft}, ${colors.amberSoft});
  border: 2px dashed ${colors.brand};
  b {
    display: block;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${colors.brandDeep};
  }
  div {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  span {
    padding: 8px 16px;
    border-radius: ${radius.pill};
    font-size: 22px;
    font-weight: 700;
    color: ${colors.brandDark};
    background: ${colors.surface};
    box-shadow: ${shadow.card};
  }
`;

export const Question = styled.li`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-radius: ${radius.lg};
  font-size: 30px;
  font-weight: 700;
  line-height: 1.3;
  background: ${colors.surface};
  box-shadow: ${shadow.card};
`;

export const QuestionIcon = styled.span`
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: ${radius.md};
  color: #C2185B;
  background: ${colors.pinkSoft};
`;

// ---------- match_images ----------
export const MatchLayout = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.$side ? "row" : "column")};
  gap: ${(props) => (props.$side ? "28px" : "20px")};
  align-items: stretch;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const ImageGrid = styled.div`
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(${(props) => (props.$count > 12 ? 7 : props.$count > 10 ? 6 : props.$count > 6 ? 5 : props.$count > 4 ? 3 : props.$count)}, 1fr);
  gap: 16px;
`;

export const ImageTile = styled.button`
  position: relative;
  min-height: 0;
  padding: 0;
  border-radius: ${radius.lg};
  overflow: hidden;
  border: 4px solid transparent;
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  transition: transform 0.15s ease;
  ${(props) => stateColors(props.$state)}

  &:hover {
    transform: ${(props) => (props.$clickable ? "scale(1.02)" : "none")};
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const TileLetter = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 800;
  color: ${colors.ink};
  background: #FFFFFF;
  box-shadow: ${shadow.card};
`;

export const TileWord = styled.span`
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  width: max-content;
  max-width: calc(100% - 16px);
  padding: ${(props) => (props.$small ? "3px 8px" : "6px 14px")};
  border-radius: 18px;
  font-size: ${(props) => (props.$small ? "15px" : "24px")};
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
  color: #FFFFFF;
  background: ${(props) => (props.$state === "bad" ? colors.danger : colors.success)};
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
`;

// слова колонкою праворуч від фото (≤ 6 фото й слів) — фото більші
export const SideChips = styled(Chips)`
  flex: 0 0 330px;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: center;

  & > button {
    text-align: center;
  }

  & > button:last-child {
    align-self: center;
  }
`;

export const Chip = styled.button`
  padding: ${(props) => (props.$small ? "6px 14px" : "12px 22px")};
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: ${(props) => (props.$small ? "20px" : "26px")};
  font-weight: 800;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : colors.surface)};
  border: 3px solid ${(props) => (props.$active ? colors.brand : colors.line)};
  box-shadow: ${(props) => (props.$active ? shadow.button(colors.brandDeep) : shadow.card)};
  opacity: ${(props) => (props.$used ? 0.35 : 1)};
  cursor: pointer;
  transition: transform 0.1s ease;

  &:active {
    transform: translateY(2px);
  }
`;

export const Reset = styled.button`
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  color: ${colors.muted};
  background: ${colors.surface};
  border: 2px solid ${colors.line};
  cursor: pointer;
`;

// ---------- match_pairs ----------
export const Pairs = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.$wide ? "1.45fr 1fr" : "1fr 1fr")};
  min-height: 0;
  gap: 40px;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const PairColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: safe center;
  min-height: 0;
  overflow-y: auto; /* у крайньому разі — прокрутка, а не обрізаний рядок */
  gap: ${(props) => (props.$compact ? "6px" : "10px")};

  /* 7+ пар — компактніше, щоб усе влізло */
  ${(props) => props.$compact && css`
    button {
      padding: 7px 14px;
      font-size: 18px;
    }
  `}
`;

export const PairItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  border-radius: ${radius.md};
  text-align: left;
  font-family: ${font.text};
  font-size: 22px;
  font-weight: 700;
  color: ${colors.ink};
  background: ${(props) => (props.$active ? colors.brandSoft : colors.surface)};
  border: 3px solid ${(props) => (props.$active ? colors.brand : colors.line)};
  opacity: ${(props) => (props.$used ? 0.4 : 1)};
  cursor: pointer;
  ${(props) => stateColors(props.$state)}

  b {
    color: ${colors.brandDeep};
  }
`;

export const PairValue = styled.span`
  margin-left: auto;
  font-weight: 800;
  color: ${(props) => (props.$state === "bad" ? colors.danger : props.$state === "late" ? colors.amberDeep : colors.success)};
  cursor: pointer;
`;

// Історія неправильних спроб (бачить учитель у зданому ДЗ)
export const Tries = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: ${colors.danger};
  text-decoration: line-through;
`;

// ---------- cards ----------
export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$cols || Math.min(props.$count, 4)}, 1fr);
  gap: ${(props) => (props.$small ? "10px" : "16px")};
  height: 100%;
  align-content: center;
  animation: ${rise} 0.4s ease-out;
`;

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: ${(props) => (props.$small ? "0" : "150px")};
  padding: ${(props) => (props.$small ? "8px" : "16px")};
  border-radius: ${radius.lg};
  font-family: ${font.text};
  color: ${(props) => (props.$flipped ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$flipped ? colors.brand : colors.surface)};
  box-shadow: ${shadow.card};
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  img {
    width: 100%;
    height: ${(props) => props.$imgH || 120}px;
    object-fit: cover;
    border-radius: ${radius.md};
  }
`;

export const CardText = styled.span`
  font-size: 30px;
  font-weight: 800;
`;

export const CardHint = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.muted};
`;

// ---------- fill_gaps / listen_write ----------
// $compact — для довгих діалогів (> 6 реплік), щоб усе вміщалося на слайді
export const Fill = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "12px" : "22px")};
  animation: ${rise} 0.4s ease-out;

  ${(props) => props.$compact && css`
    p {
      font-size: 22px;
      line-height: 1.45;
    }
    > div:last-child {
      gap: 6px;
    }
  `}
  ${(props) => props.$dense && css`
    p {
      font-size: 21px;
      line-height: 1.3;
    }
    h3 {
      margin-top: 4px;
    }
    div {
      gap: 3px;
    }
  `}
`;

export const Bank = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 18px;
  border-radius: ${radius.lg};
  border: 2px dashed ${colors.line};
  background: ${colors.surface};
`;

export const BankWord = styled.button`
  padding: 6px 14px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 22px;
  font-weight: 700;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.brandDeep)};
  background: ${(props) => (props.$active ? colors.brand : colors.brandSoft)};
  opacity: ${(props) => (props.$used ? 0.35 : 1)};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const Lines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Line = styled.p`
  display: flex;
  gap: 14px;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.6;

  /* текст рядка не ширший за колонку — довгі пропуски не вилазять за край */
  > span:last-child {
    flex: 1;
    min-width: 0;
  }
`;

export const Speaker = styled.span`
  flex-shrink: 0;
  min-width: 96px;
  font-weight: 800;
  color: ${colors.brandDeep};
`;

export const GapInput = styled.input`
  width: calc(${(props) => props.$size}ch + 20px);
  max-width: 100%;
  margin: 0 4px;
  padding: 0 6px;
  border: none;
  border-bottom: 3px solid ${colors.brand};
  border-radius: 6px 6px 0 0;
  font-family: ${font.text};
  font-size: inherit;
  font-weight: 800;
  text-align: center;
  color: ${colors.ink};
  background: ${(props) => (props.$over ? colors.amberSoft : colors.brandSoft)};
  outline: ${(props) => (props.$over ? `2px dashed ${colors.amber}` : "none")};
  ${(props) =>
    props.$state === "ok"
      ? css`border-bottom-color: ${colors.success}; background: ${colors.successSoft}; color: ${colors.success};`
      : props.$state === "bad"
      ? css`border-bottom-color: ${colors.danger}; background: ${colors.dangerSoft};`
      : ""}
  ${(props) =>
    props.$slot &&
    css`
      display: inline-block;
      vertical-align: baseline;
      line-height: 1.35;
      cursor: pointer;
      user-select: none;
      white-space: nowrap;
    `}
`;

export const ExampleGap = styled.span`
  margin: 0 4px;
  padding: 0 10px;
  border-bottom: 3px solid ${colors.amber};
  border-radius: 6px 6px 0 0;
  font-weight: 800;
  color: ${colors.ink};
  background: ${colors.amberSoft};
`;

export const FillExample = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 10px;
  margin-bottom: 8px;
  padding: 4px 12px;
  border-radius: ${radius.md};
  font-weight: 600;
  color: ${colors.ink};
  background: ${colors.amberSoft};

  em {
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${colors.amberDeep};
  }
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 40px;
`;

export const LinesHeading = styled.h3`
  font-size: 20px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${colors.muted};
`;

export const ListenLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 100%;
  justify-content: center;
`;

export const ListenExample = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 24px;
  border-radius: ${radius.lg};
  border: 2px dashed ${colors.line};
  background: ${colors.surface};
  font-size: 26px;
  font-weight: 600;

  span {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  i {
    font-style: normal;
    color: ${colors.brandDeep};
  }

  b {
    padding: 0 10px;
    border-radius: 6px;
    color: ${colors.success};
    background: ${colors.successSoft};
  }

  small {
    font-size: 20px;
    color: ${colors.muted};
  }
`;

export const ExampleTag = styled.em`
  padding: 4px 10px;
  border-radius: ${radius.pill};
  font-size: 15px;
  font-style: normal;
  font-weight: 800;
  text-transform: uppercase;
  color: #FFFFFF;
  background: ${colors.amber};
`;

export const Dictation = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px 24px;
  align-content: center;
  font-size: 32px;
  animation: ${rise} 0.4s ease-out;
`;

export const DictationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 14px 18px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  b {
    color: ${colors.brandDeep};
  }
`;

// ---------- order ----------
export const OrderLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const OrderPool = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  gap: 12px;
`;

export const OrderList = styled.ol`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
`;

export const OrderSlot = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 52px;
  padding: 8px 16px;
  border-radius: ${radius.md};
  font-size: 24px;
  font-weight: 800;
  border: 3px ${(props) => (props.$filled ? "solid" : "dashed")} ${colors.line};
  background: ${(props) => (props.$filled ? colors.surface : "transparent")};
  ${(props) => stateColors(props.$state)}

  b {
    width: 28px;
    color: ${colors.brandDeep};
  }
`;

// ---------- phrases ----------
export const PhraseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${(props) => (props.$count > 3 ? 2 : 1)}, 1fr);
  gap: 18px;
  align-content: center;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const Phrase = styled.div`
  padding: 24px 28px;
  border-radius: ${radius.lg};
  font-size: 32px;
  font-weight: 800;
  background: ${colors.surface};
  border-left: 8px solid ${colors.amber};
  box-shadow: ${shadow.card};
`;

// ---------- game / homework ----------
export const Rules = styled.ol`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const Rule = styled.li`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 22px;
  border-radius: ${radius.lg};
  font-size: 28px;
  font-weight: 700;
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  > b {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 50%;
    color: #FFFFFF;
    background: ${colors.brand};
  }

  strong {
    display: block;
  }

  small {
    display: block;
    margin-top: 4px;
    font-size: 20px;
    font-weight: 600;
    color: ${colors.muted};
  }
`;

export const Chat = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
`;

export const Bubble = styled.p`
  align-self: ${(props) => (props.$right ? "flex-end" : "flex-start")};
  max-width: 80%;
  padding: 14px 22px;
  border-radius: 24px;
  border-bottom-${(props) => (props.$right ? "right" : "left")}-radius: 6px;
  font-size: 30px;
  font-weight: 800;
  color: ${(props) => (props.$right ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$right ? colors.brand : colors.surface)};
  box-shadow: ${shadow.card};
`;

// ---------- quiz ----------
export const Quiz = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;

export const QuizProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const QuizDot = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${(props) => (props.$state === "ok" ? colors.success : props.$state === "bad" ? colors.danger : colors.line)};
  outline: ${(props) => (props.$current ? `3px solid ${colors.brand}` : "none")};
  outline-offset: 2px;
`;

export const QuizScore = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  font-size: 26px;
  font-weight: 800;
`;

export const QuizQuestion = styled.p`
  font-size: 38px;
  font-weight: 800;
  line-height: 1.25;
`;

export const QuizOptions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`;

export const QuizOption = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-radius: ${radius.lg};
  font-family: ${font.text};
  font-size: 28px;
  font-weight: 800;
  text-align: left;
  color: ${colors.ink};
  background: ${colors.surface};
  border: 3px solid ${colors.line};
  cursor: pointer;
  ${(props) => stateColors(props.$state)}
`;

export const QuizNext = styled.button`
  align-self: flex-end;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 22px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
`;

// ---------- summary ----------
export const Learned = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 14px;
`;

export const LearnedItem = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 30px;
  font-weight: 700;
`;

export const HomeworkCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 32px;
  border-radius: ${radius.xl};
  text-align: center;
  color: #FFFFFF;
  background: linear-gradient(135deg, ${colors.brandDark} 0%, ${colors.brandDeep} 70%, ${colors.brand} 100%);
  box-shadow: ${shadow.raised};

  b {
    font-size: 34px;
    font-weight: 800;
    line-height: 1.2;
  }

  span {
    font-size: 22px;
    font-weight: 600;
    opacity: 0.85;
  }
`;
